import { useState } from 'react';

export const ListFormCard = ({ icon, title, badge, badgeTone = 'muted', children, className = '' }) => (
  <section className={`list-v2-card ${className}`.trim()}>
    <header className="list-v2-card__header">
      <div className="list-v2-card__title-wrap">
        <span className="list-v2-card__icon" aria-hidden="true">
          <i className={`fas fa-${icon}`}></i>
        </span>
        <h2 className="list-v2-card__title">{title}</h2>
      </div>
      {badge ? (
        <span className={`list-v2-badge list-v2-badge--${badgeTone}`}>{badge}</span>
      ) : null}
    </header>
    <div className="list-v2-card__body">{children}</div>
  </section>
);

export const ListFormCollapsible = ({
  icon,
  title,
  badge,
  badgeTone = 'muted',
  defaultOpen = false,
  hint,
  children,
}) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className={`list-v2-card list-v2-card--collapsible${open ? ' is-open' : ''}`}>
      <button
        type="button"
        className="list-v2-card__toggle"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
      >
        <div className="list-v2-card__title-wrap">
          <span className="list-v2-card__icon list-v2-card__icon--muted" aria-hidden="true">
            <i className={`fas fa-${icon}`}></i>
          </span>
          <h2 className="list-v2-card__title">{title}</h2>
          {badge ? (
            <span className={`list-v2-badge list-v2-badge--${badgeTone}`}>{badge}</span>
          ) : null}
        </div>
        <i className={`fas fa-chevron-down list-v2-card__chevron${open ? ' is-open' : ''}`} aria-hidden="true"></i>
      </button>
      {open ? (
        <div className="list-v2-card__body list-v2-card__body--collapsible">
          {hint ? <p className="list-v2-hint">{hint}</p> : null}
          {children}
        </div>
      ) : null}
    </section>
  );
};

export const ListFormField = ({ label, helper, required, htmlFor, children, className = '' }) => (
  <div className={`list-v2-field ${className}`.trim()}>
    {label ? (
      <label className="list-v2-field__label" htmlFor={htmlFor}>
        {label}
        {required ? <span className="list-v2-required" aria-hidden="true">*</span> : null}
      </label>
    ) : null}
    {helper ? <p className="list-v2-field__helper">{helper}</p> : null}
    {children}
  </div>
);

export const ListFormToggle = ({ label, description, checked, onChange, disabled }) => (
  <div className="list-v2-toggle-row">
    <div className="list-v2-toggle-copy">
      <p className="list-v2-toggle-label">{label}</p>
      {description ? <p className="list-v2-toggle-desc">{description}</p> : null}
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      className={`list-v2-toggle${checked ? ' is-on' : ''}`}
      onClick={() => onChange(!checked)}
      disabled={disabled}
    >
      <span className="list-v2-toggle__thumb" />
    </button>
  </div>
);

export const ListFormNotice = ({ icon = 'shield-alt', tone = 'accent', children }) => (
  <div className={`list-v2-notice list-v2-notice--${tone}`}>
    <i className={`fas fa-${icon}`} aria-hidden="true"></i>
    <div>{children}</div>
  </div>
);

export const listV2InputClass = 'list-v2-input';
export const listV2SelectClass = 'list-v2-select';
export const listV2TextareaClass = 'list-v2-textarea';
